import type { ParcelConfig } from 'single-spa';

import {
    ChatBlkPromptSource,
    FollowUpPrompt,
    PromptAnswer,
    PromptAnswerOutput,
} from '../types';

export enum QueryState {
    LOADING = 'loading',
    LOADED = 'loaded',
    CANCELED = 'canceled',
}

export enum QueryTypeEnum {
    QUERY = 'query',
    SUMMARIZE = 'summarize',
    CONTACT_RM = 'contact-rm',
}

export interface QueryFeedback {
    rating: number;
    feedbackCategories: Array<string>;
    feedbackComment: string;
    feedbackRewrite: string;
    isThumbsUp?: boolean;
}

export interface QueryCustomFeedback {
    questionCategory: number;
    answerRating: number;
    relatedRating: number;
}

/**
 * - CHAT_EXCHANGE_SCOPE_UNSPECIFIED: Default value  - CHAT_EXCHANGE_SCOPE_INSIGHTS: Insights  - CHAT_EXCHANGE_SCOPE_PRODUCTS: Products  - CHAT_EXCHANGE_SCOPE_OUT_OF_SCOPE: Out-Of-Scope
 * @export
 * @enum {string}
 */
export enum ChatBlkQueryScopeEnum {
    UNSPECIFIED = 'CHAT_EXCHANGE_SCOPE_UNSPECIFIED',
    INSIGHTS = 'CHAT_EXCHANGE_SCOPE_INSIGHTS',
    PRODUCT = 'CHAT_EXCHANGE_SCOPE_PRODUCTS',
    OUT_OF_SCOPE = 'CHAT_EXCHANGE_SCOPE_OUT_OF_SCOPE',
    INVESTMENT_ADVICE_SCOPE = 'CHAT_EXCHANGE_SCOPE_INVESTMENT_ADVICE',
}

export interface ChatBlkQuery
    extends Partial<QueryFeedback>,
        Partial<QueryCustomFeedback> {
    id: string;
    hashId?: string;
    sessionId: string;
    query: string;
    chatBlkEventId: string;
    chatOriginUri?: string;
    followUpPrompts?: Array<FollowUpPrompt>;
    response?: string;
    timestampUtc?: number;
    sources?: Array<ChatBlkPromptSource>;
    scope?: ChatBlkQueryScopeEnum;
    userTimestamp: string;
    state?: QueryState;
    responseTimestamp?: string;
    answerRating?: number;
    output?: PromptAnswerOutput;
    chatExchangeId?: string;
    queryType?: QueryTypeEnum;
}

export type ChatBlkQueries = Array<ChatBlkQuery>;

export type QueryResult = MarkdownQueryResult | ParcelQueryResult;

export interface MarkdownQueryResult {
    response: string | ParcelConfig | PromptAnswer;
    type: QueryResultType.MARKDOWN;
}

export interface ParcelQueryResult {
    response: ParcelConfig;
    type: QueryResultType.MFE;
}

export enum QueryResultType {
    MARKDOWN = 'markdown',
    MFE = 'mfe',
}
